<sis-tiny-badge [variant]="state === 'ACTIVE' ? 'success' : state === 'DELETED' ? 'danger' : 'accent'">
  {{'VISIBLE_DOCUMENT_STATE.' + state | translate}}
</sis-tiny-badge>
